import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=12927f40&scoped=true&"
import script from "./Icons.vue?vue&type=script&lang=ts&"
export * from "./Icons.vue?vue&type=script&lang=ts&"
import style0 from "./Icons.vue?vue&type=style&index=0&id=12927f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12927f40",
  null
  
)

component.options.__file = "Icons.vue"
export default component.exports